import { createContext, useContext } from 'react';

import type { AuthenticatedUser } from '@dcc-erp/shared';

export interface AuthContextValue {
  /** Null until /auth/me has resolved or there is no signed-in account. */
  user: AuthenticatedUser | null;
  isAuthenticated: boolean;
  isLoading: boolean;
  /** Null when the user has no allowed companies or `/me` has not loaded yet. */
  activeCompanyId: string | null;
  setActiveCompanyId: (companyId: string) => void;
  login: () => Promise<void>;
  logout: () => Promise<void>;
  /**
   * Acquire an access token for the API scope. Falls back to redirect (full
   * page reload) if an interaction is required, in which case this promise
   * never resolves locally.
   */
  getAccessToken: () => Promise<string>;
}

export const AuthContext = createContext<AuthContextValue | null>(null);

export function useAuth(): AuthContextValue {
  const ctx = useContext(AuthContext);
  if (!ctx) {
    throw new Error('useAuth() called outside <AuthProvider>');
  }
  return ctx;
}

export const ACTIVE_COMPANY_STORAGE_KEY = 'dcc-erp/active-company';
